import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../api';

import {
  scaVerifyRedirectSuccess,
  scaVerifyRedirectFailure,
} from '../actions';

import { SCA_VERIFY_REDIRECT_PARAMS } from '../constants';

export function* scaVerifyRedirect(action) {
  try {
    const { controlStatus } = action.payload;

    // Validate the status parameters before calling the API
    if (controlStatus !== 'VALIDATED') {
      yield put(scaVerifyRedirectFailure({
        message: 'SCA session or action failed',
        result: {
          controlStatus,
        },
      }));
      return;
    }

    const mangoUser = yield call(api.getMangoPayUser);

    // Validate that the user is active, i.e., has completed the SCA process
    if (mangoUser?.UserStatus !== 'ACTIVE') {
      yield put(scaVerifyRedirectFailure({
        message: 'Your MangoPay account has not been fully verified. Please complete the SCA process.',
        result: { controlStatus },
      }));
      return;
    }

    yield put(scaVerifyRedirectSuccess({
      mangoUser,
      controlStatus,
    }));
  } catch (err) {
    const message =
      err?.response?.data?.message ||
      err?.response?.data ||
      err?.message ||
      'Unknown verification error';

    // Handle specific error messages
    const useMessage = message === 'User does not have a mangopay id'
      ? 'Your account is missing some required information to complete this action.'
      : message;

    const { controlStatus } = action.payload;

    yield put(scaVerifyRedirectFailure({
      message: useMessage,
      result: {
        controlStatus,
      },
    }));
  }
}

export function* watchSCAVerification() {
  yield takeLatest(SCA_VERIFY_REDIRECT_PARAMS, scaVerifyRedirect);
}

export default [
  watchSCAVerification(),
];
